"use client";

import { WindowEventListenersEnum } from "@/constants/constants";
import { getStatsigReady } from "@/utils/window.helpers";
import { useEffect, useState } from "react";

/**
 * Custom hook to track Statsig initialization state
 * Listens for the STATSIG_READY event and checks the current ready state
 *
 * @returns {boolean} isStatsigReady - True when Statsig is initialized and ready to use
 */
export const useStatsigReady = (): boolean => {
  const [isStatsigReady, setIsStatsigReady] = useState(false);

  useEffect(() => {
    // Check if Statsig is already ready (in case the event fired before this component mounted)
    if (getStatsigReady()) {
      setIsStatsigReady(true);
    }

    const handleStatsigReady = () => {
      setIsStatsigReady(true);
    };

    window.addEventListener(
      WindowEventListenersEnum.STATSIG_READY,
      handleStatsigReady,
    );

    return () => {
      window.removeEventListener(
        WindowEventListenersEnum.STATSIG_READY,
        handleStatsigReady,
      );
    };
  }, []);

  return isStatsigReady;
};
